import AuthUserModelInterface from 'src/app/kernel/shared/interfaces/auth-user-model.interface';
import {IRole, ISpaceRole, ISpaceType, IUser} from '../interfaces';
import { EUserType } from '../enums';

export class AuthUserModel implements AuthUserModelInterface {
  constructor(
    public id: string,
    public fullName: string,
    public email: string,
    public permissions: string[],
    public roles: IRole[],
    public mobile : string,
    public name : string,
    public surname : string,
    public type : EUserType,
    public activeSpace: ISpaceType,
    public createdAt: Date,
    public updatedAt: Date,
    public hasVerifiedEmail: boolean,
    public hasVerifiedMobile: boolean,
    public is2FAEnabled: boolean,
    public isActive: boolean
  ){}

  static create(data: IUser): AuthUserModel {
    var permissions : string[];
    if(data.type == EUserType.Customer){
      if (!data.activeSpace || !data.activeSpace.users) {
        permissions = [];
      } else {
        permissions = data.activeSpace.users[0].role!.permissions;
      }
    }else {
      permissions = (data.roles as IRole[]).flatMap((role) => role.permissions);
    }
    const {
      id,
      email,
      personalInfo,
      roles,
      mobile,
      type,
      activeSpace,
      createdAt,
      hasVerifiedEmail,
      hasVerifiedMobile,
      is2FAEnabled,
      isActive,
      updatedAt
    } = data;
    const { name, surname} = personalInfo || {name:'',surname:''};
    return new AuthUserModel(
      id,
      `${name} ${surname}`,
      email,
      permissions,
      roles as IRole[],
      mobile,
      name,
      surname,
      type,
      activeSpace,
      createdAt,
      updatedAt,
      hasVerifiedEmail,
      hasVerifiedMobile,
      is2FAEnabled,
      isActive
    );
  }

  public can(permission: string | (string | string[])[]): boolean {
    if (!permission) {
      return true;
    }
    if (this.permissions.includes('SUPER_ADMIN')) {
      return true;
    }
    if (typeof permission === 'string') {
      permission = [permission];
    }
    return this.doPermissionsCheck(this.permissions, permission);
  }
  /**
   * does an or check on permissions, taking and check in consideration.
   * @param owned
   * @param required
   */
  private doPermissionsCheck(
    owned: string[],
    required: (string | string[])[]
  ): boolean {
    if (!required || !required.length) {
      return true;
    }
    return required.some((_permission) =>
      typeof _permission === 'object'
        ? this.doAndPermissionsCheck(owned, <string[]>_permission)
        : owned.indexOf(<string>_permission) !== -1
    );
  }

  /**
   * does an and condition on permissions.
   * @param owned
   * @param required
   */
  private doAndPermissionsCheck(owned: string[], required: string[]): boolean {
    return required.every((_permission) => owned.includes(_permission));
  }

  public toUserObject(): IUser {
    return {
      id: this.id,
      email: this.email,
      personalInfo: {
        name: this.name,
        surname: this.surname,
      },
      roles: this.roles,
      mobile: this.mobile,
      type: this.type,
      activeSpace: this.activeSpace,
      is2FAEnabled: this.is2FAEnabled,
      createdAt: this.createdAt,
      hasVerifiedEmail: this.hasVerifiedEmail,
      hasVerifiedMobile: this.hasVerifiedMobile,
      isActive: this.isActive,
      updatedAt: this.updatedAt
    };
  }
}
